import DeleteAssignmentDialog from './template'

export default DeleteAssignmentDialog
